export default {
  reportRecommendations: (state) => state.reportRecommendations,
  reportRecommendation: (state) => state.reportRecommendation
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/recommendations/getters.js